// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2wdIm","col":"styles_col__3GgBM"};